// extracted by mini-css-extract-plugin
module.exports = {"count":"legislative_text_snippet-module__count--2Yb4E"};